import React, { useMemo, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Navigation } from '../../../global-functions';
import { isMiracleEar } from '../../../hooks/miracle-ear-hook';
import { RootState } from '../../../store';
import { ISession } from '../../../models/pro-sites';
import {
    IOption,
    IProductDetail,
    IReceiverPart,
} from '../../../models/product-detail';
import { addReceiversToCart } from '../../../store/product/product-detail-actions';
import { findReceiverDuplicates } from '../product-details/validation';
import ReceiverSelect from './receiver-select';
import * as CON from '../../common/constants';
import './product-list.css';
import { G23Hook } from '../../../hooks/G23-hook';
import { KR } from '../../common/constants';
import ProductGuidePDF from './ProductGuidePDF';
import CompatibilityList from './compatibility-list';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux-hooks';

export const ReceiversSelect = () => {
    const intl = useIntl();
    const dispatch = useAppDispatch();
    const session = useAppSelector((state: RootState) =>
        state.session ? state.session.data! : null
    );
    const maxQuantity = session!.settings!.MaxQuantity;
    const [errorStateOptions, setErrorStateOptions] = useState<boolean>(false);
    const [errorStateQuantity, setErrorStateQuantity] =
        useState<boolean>(false);
    const [snap2State, setSnap2State] = useState<IReceiverPart[]>([
        {} as IReceiverPart,
    ]);
    const [snapState, setSnapState] = useState<IReceiverPart[]>([
        {} as IReceiverPart,
    ]);

    const [originalState, setOriginalState] = useState<IReceiverPart[]>([
        {} as IReceiverPart,
    ]);

    const [cros2State, setCros2State] = useState<IReceiverPart[]>([
        {} as IReceiverPart,
    ]);
    const [crosState, setCrosState] = useState<IReceiverPart[]>([
        {} as IReceiverPart,
    ]);
    const updateSnap2Receivers = (receivers: IReceiverPart[]) => {
        setSnap2State(receivers);
    };

    const updateSnapReceivers = (receivers: IReceiverPart[]) => {
        setSnapState(receivers);
    };

    const updateOriginalReceivers = (receivers: IReceiverPart[]) => {
        setOriginalState(receivers);
    };

    const updateCros2Receivers = (receivers: IReceiverPart[]) => {
        setCros2State(receivers);
    };
    const updateCrosReceivers = (receivers: IReceiverPart[]) => {
        setCrosState(receivers);
    };
    //DO WE NEED TO UPDATE ALL 2.0s TO BE UseAngledParts: false
    const onAddToCart = async () => {
        let receivers = [] as IReceiverPart[];
        if (snap2State) {
            receivers = receivers.concat(
                snap2State
                    .filter(
                        (x) =>
                            x.side &&
                            x.side.length > 0 &&
                            x.cableLength &&
                            x.cableLength > 0 &&
                            x.gain &&
                            x.gain.length > 0 &&
                            x.quantity &&
                            x.quantity > 0
                    )
                    .map((x) => {
                        return {
                            ...x,
                            useAngledParts: false,
                            partType: CON.ReceiverType.SnapFit2,
                        };
                    })
            );
        }
        if (snapState) {
            receivers = receivers.concat(
                snapState
                    .filter(
                        (x) =>
                            x.side &&
                            x.side.length > 0 &&
                            x.cableLength &&
                            x.cableLength > 0 &&
                            x.gain &&
                            x.gain.length > 0 &&
                            x.quantity &&
                            x.quantity > 0
                    )
                    .map((x) => {
                        return {
                            ...x,
                            useAngledParts: true,
                            partType: CON.ReceiverType.SnapFit,
                        };
                    })
            );
        }

        if (originalState) {
            receivers = receivers.concat(
                originalState
                    .filter(
                        (x) =>
                            x.side &&
                            x.side.length > 0 &&
                            x.cableLength &&
                            x.cableLength > 0 &&
                            x.gain &&
                            x.gain.length > 0 &&
                            x.quantity &&
                            x.quantity > 0
                    )
                    .map((x) => {
                        return {
                            ...x,
                            useAngledParts: false,
                            partType: CON.ReceiverType.NonSnapFit,
                        };
                    })
            );
        }
        if (cros2State) {
            receivers = receivers.concat(
                cros2State
                    .filter(
                        (x) =>
                            x.side &&
                            x.side.length > 0 &&
                            x.cableLength &&
                            x.cableLength > 0 &&
                            x.quantity &&
                            x.quantity > 0
                    )
                    .map((x) => {
                        return {
                            ...x,
                            gain: 'N/A',
                            useAngledParts: false,
                            partType: CON.ReceiverType.SnapFit2,
                        };
                    })
            );
        }
        if (crosState) {
            receivers = receivers.concat(
                crosState
                    .filter(
                        (x) =>
                            x.side &&
                            x.side.length > 0 &&
                            x.cableLength &&
                            x.cableLength > 0 &&
                            x.quantity &&
                            x.quantity > 0
                    )
                    .map((x) => {
                        return {
                            ...x,
                            gain: 'N/A',
                            useAngledParts: true,
                            partType: CON.ReceiverType.SnapFit,
                        };
                    })
            );
        }

        if (
            findReceiverDuplicates(
                receivers,
                (r) => {
                    const { quantity, ...rest } = r;
                    return Object.values(rest).join('');
                },
                (r) => r.quantity
            )
        ) {
            setErrorStateQuantity(true);
            return;
        }
        if (receivers.length > 0) {
            await dispatch(addReceiversToCart(receivers));
            setSnap2State([{} as IReceiverPart]);

            setSnapState([{} as IReceiverPart]);

            setOriginalState([{} as IReceiverPart]);

            setCros2State([{} as IReceiverPart]);

            setCrosState([{} as IReceiverPart]);

            setErrorStateOptions(false);

            setErrorStateQuantity(false);

            Navigation.pushExternal('/prosite/estore/cart');
        } else {
            setErrorStateOptions(true);
        }
    };
    const snap2 = {
        designId: 9189,
        options: [
            {
                id: 8,
                items: [
                    { name: '1' },
                    { name: '2' },
                    { name: '3' },
                    { name: '4' },
                    { name: '5' },
                ] as IOption[],
            },
            {
                id: 19,
                items: [
                    {
                        name: 'Gain_L',
                        english: 'L',
                    },
                    {
                        name: 'Gain_M',
                        english: 'M',
                    },
                    {
                        name: 'Gain_P',
                        english: 'P',
                    },
                ] as IOption[],
            },
        ] as IOption[],
    } as IProductDetail;

    const snap = {
        designId: 39,
        options: [
            {
                id: 8,
                items: [
                    { name: '1' },
                    { name: '2' },
                    { name: '3' },
                    { name: '4' },
                    { name: '5' },
                ] as IOption[],
            },
            {
                id: 19,
                items: ['BR'].includes(session!.country)
                    ? ([{ name: '115/50' }, { name: '120/60' }] as IOption[])
                    : ([
                          { name: '107/40' },
                          { name: '115/50' },
                          { name: '120/60' },
                      ] as IOption[]),
            },
        ] as IOption[],
    } as IProductDetail;

    const original = {
        designId: 40,
        options: [
            {
                id: 8,
                items: [
                    { name: '1' },
                    { name: '2' },
                    { name: '3' },
                    { name: '4' },
                    { name: '5' },
                ] as IOption[],
            },
            {
                id: 19,
                items: ['BR', 'IT', 'UK'].includes(session!.country)
                    ? ([{ name: '115/50' }, { name: '120/60' }] as IOption[])
                    : ([
                          { name: '110/40' },
                          { name: '115/50' },
                          { name: '120/60' },
                      ] as IOption[]),
            },
        ] as IOption[],
    } as IProductDetail;
    const cros2 = {
        designId: 9195,
        options: [
            {
                id: 8,
                items: [
                    { name: '1' },
                    { name: '2' },
                    { name: '3' },
                    { name: '4' },
                    { name: '5' },
                ] as IOption[],
            },
        ] as IOption[],
    } as IProductDetail;
    const cros = {
        designId: 37,
        options: [
            {
                id: 8,
                items: [
                    { name: '1' },
                    { name: '2' },
                    { name: '3' },
                    { name: '4' },
                    { name: '5' },
                ] as IOption[],
            },
        ] as IOption[],
    } as IProductDetail;

    return (
        <div id="wrapper" style={{ paddingBottom: '80px' }}>
            <div>
                <h1>
                    <FormattedMessage id="Receivers" />
                </h1>
            </div>
            {CON.RECEIVER_PRODUCT_GUIDE_COUNTRIES.includes(session!.country) &&
                CON.RECEIVER_PRODUCT_GUIDE_BRANDS.includes(
                    session!.selectedBrand
                ) && (
                    <ProductGuidePDF
                        titleDefault={'{0} Receiver Guide'}
                        descriptionDefault={
                            'Use this guide to help you select the most appropriate receiver for your patient.'
                        }
                        linkKey={'receiver_guide'}
                        linkDefault={
                            'https://cdn.mediavalet.com/usil/starkeyhearingtech/5JDgH6wAu0m6TcVhJfcmVg/sLqSOGVduEelk9eFVLAljQ/Original/Genesis%20Matrix%20Graphics.pdf'
                        }
                        downloadTextDefault={
                            'Download the {0} Receiver Guide (PDF)'
                        }
                    />
                )}
            <div>
                {session && G23Hook(session) && (
                    <>
                        <div className="flex">
                            <h2>
                                <FormattedMessage
                                    id="SnapFit_20_Receivers"
                                    defaultMessage="SnapFit 2.0 Receivers"
                                />
                            </h2>
                            <CompatibilityList
                                compatibilityList={session!.compatibilityList}
                                designId={snap2.designId}
                            />
                        </div>

                        <div className="row row-m-b">
                            <div className="col-md-12 col-sm-12">
                                <ReceiverSelect
                                    productState={snap2}
                                    receivers={snap2State}
                                    updateReceivers={updateSnap2Receivers}
                                    receiver={null}
                                    maxQuantity={maxQuantity}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div>
                    <div className="flex">
                        <h2>
                            <FormattedMessage id="Snap_Fit_Receivers" />
                            <span
                                className="glyphicon glyphicon-info-sign"
                                aria-hidden="true"
                                title={
                                    session!.selectedBrand === 'Audibel'
                                        ? intl.formatMessage({
                                              id: '40_Gain_Receivers_Not_Compatible_List_Audibel',
                                          })
                                        : session!.selectedBrand === 'NuEar'
                                        ? intl.formatMessage({
                                              id: '40_Gain_Receivers_Not_Compatible_List_NuEar',
                                          })
                                        : intl.formatMessage({
                                              id: '40_Gain_Receivers_Not_Compatible_List_Starkey',
                                          })
                                }
                                style={{ paddingLeft: '5px' }}
                            />
                        </h2>
                        {isMiracleEar(session!.siteNumber) && (
                            <CompatibilityList
                                compatibilityList={session!.compatibilityList}
                                designId={snap.designId}
                            />
                        )}
                    </div>
                </div>
                <div className="row row-m-b">
                    <div className="col-md-12 col-sm-12">
                        <ReceiverSelect
                            productState={snap}
                            receivers={snapState}
                            updateReceivers={updateSnapReceivers}
                            receiver={null}
                            maxQuantity={maxQuantity}
                        />
                    </div>
                </div>

                {!isMiracleEar(session!.siteNumber) &&
                    session!.country !== KR && (
                        <>
                            <div>
                                <h2>
                                    <FormattedMessage id="Original_Fit_Receivers" />
                                </h2>
                            </div>
                            <div className="row row-m-b">
                                <div className="col-md-12 col-sm-12">
                                    <ReceiverSelect
                                        productState={original}
                                        receivers={originalState}
                                        updateReceivers={
                                            updateOriginalReceivers
                                        }
                                        receiver={null}
                                        maxQuantity={maxQuantity}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                {session && G23Hook(session) && (
                    <>
                        <div className="flex">
                            <h2>
                                <FormattedMessage
                                    id="Non-Functional_Snap_Fit_20_CROS_Receivers"
                                    defaultMessage="Non-Functional SnapFit 2.0 CROS Receivers"
                                />
                            </h2>
                            <CompatibilityList
                                compatibilityList={session!.compatibilityList}
                                designId={cros2.designId}
                            />
                        </div>

                        <div className="row row-m-b">
                            <div className="col-md-12 col-sm-12">
                                <ReceiverSelect
                                    productState={cros2}
                                    receivers={cros2State}
                                    updateReceivers={updateCros2Receivers}
                                    receiver={null}
                                    maxQuantity={maxQuantity}
                                />
                            </div>
                        </div>
                    </>
                )}
                <div>
                    <div className="flex">
                        <h2>
                            <FormattedMessage id="Non-Functional_Snap_Fit_CROS_Receivers" />
                        </h2>
                        {isMiracleEar(session!.siteNumber) && (
                            <CompatibilityList
                                compatibilityList={session!.compatibilityList}
                                designId={cros.designId}
                            />
                        )}
                    </div>
                </div>
                <div className="row row-m-b">
                    <div className="col-md-12 col-sm-12">
                        <ReceiverSelect
                            productState={cros}
                            receivers={crosState}
                            updateReceivers={updateCrosReceivers}
                            receiver={null}
                            maxQuantity={maxQuantity}
                        />
                    </div>
                </div>
            </div>
            {errorStateOptions && (
                <div className="row row-m-b" style={{ padding: '0px 15px' }}>
                    <div
                        className="col-md-12 alert alert-danger"
                        style={{ margin: '0px 0px 5px 0px' }}
                    >
                        <strong>
                            <FormattedMessage id="Receiver_Options_Required" />
                        </strong>
                    </div>
                </div>
            )}
            {errorStateQuantity && (
                <div className="row row-m-b" style={{ padding: '0px 15px' }}>
                    <div
                        className="col-md-12 alert alert-danger"
                        style={{ margin: '0px 0px 5px 0px' }}
                    >
                        <strong>
                            <FormattedMessage
                                id="Receiver_Quantity_Required"
                                defaultMessage="Receivers quantity per item cannot exceed 150"
                            />
                        </strong>
                    </div>
                </div>
            )}
            <div className="row row-m-b">
                <div className="col-md-10" />
                <div className="col-md-2">
                    <button
                        className="btn btn-primary pull-right"
                        onClick={onAddToCart}
                    >
                        <FormattedMessage id="Add_to_Cart" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReceiversSelect;
